module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.formData,
      "label-width": "140px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所属年份",
      "prop": "year",
      "rules": [{
        required: true,
        message: '请选择所属年份',
        trigger: 'blur'
      } ]
    }
  }, [_c('el-date-picker', {
    attrs: {
      "value-format": "yyyy",
      "type": "year",
      "placeholder": "请选择所属年份"
    },
    model: {
      value: (_vm.formData.year),
      callback: function($$v) {
        _vm.$set(_vm.formData, "year", $$v)
      },
      expression: "formData.year"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所属地区",
      "prop": "area",
      "rules": [{
        required: true,
        message: '点击选择省市区',
      } ]
    }
  }, [_c('el-cascader', {
    ref: "areas",
    attrs: {
      "options": _vm.areaOptions,
      "props": {
        label: 'title'
      }
    },
    on: {
      "change": _vm.handleAreasChange
    },
    model: {
      value: (_vm.formData.area),
      callback: function($$v) {
        _vm.$set(_vm.formData, "area", $$v)
      },
      expression: "formData.area"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "单位全称",
      "prop": "danwei",
      "rules": [{
        required: true,
        message: '单位名称不能为空',
        trigger: 'blur'
      } ]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入单位名称"
    },
    model: {
      value: (_vm.formData.danwei),
      callback: function($$v) {
        _vm.$set(_vm.formData, "danwei", $$v)
      },
      expression: "formData.danwei"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联络人",
      "prop": "name",
      "rules": [{
        required: true,
        message: '请输入联络人姓名',
        trigger: 'blur',
      } ]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入联络人姓名"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "身份证照片",
      "prop": "shenfenzheng_pic"
    }
  }, [_c('PicUploader', {
    attrs: {
      "fileList": _vm.formData.shenfenzheng_pic,
      "limit": 2
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-label-desc"
  }, [_vm._v("上传身份证正面、背面照片")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系电话",
      "prop": "phone",
      "rules": [{
        required: true,
        validator: _vm.validator.phone,
        message: '请输入正确的手机号',
        trigger: ['blur', 'change'],
      } ]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入联系电话"
    },
    model: {
      value: (_vm.formData.phone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phone", $$v)
      },
      expression: "formData.phone"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "微信",
      "prop": "weixin",
      "rules": [{
        required: true,
        message: '微信不能为空',
        trigger: 'blur',
      } ]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入微信"
    },
    model: {
      value: (_vm.formData.weixin),
      callback: function($$v) {
        _vm.$set(_vm.formData, "weixin", $$v)
      },
      expression: "formData.weixin"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "邮箱",
      "prop": "email",
      "rules": [{
        required: true,
        validator: _vm.validator.email,
        message: '请输入正确的邮箱',
        trigger: ['blur', 'change'],
      } ]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入邮箱"
    },
    model: {
      value: (_vm.formData.email),
      callback: function($$v) {
        _vm.$set(_vm.formData, "email", $$v)
      },
      expression: "formData.email"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "邮寄地址",
      "prop": "address",
      "rules": [{
        required: true,
        message: '地址不能为空',
        trigger: 'blur',
      } ]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入邮寄地址"
    },
    model: {
      value: (_vm.formData.address),
      callback: function($$v) {
        _vm.$set(_vm.formData, "address", $$v)
      },
      expression: "formData.address"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "人员选择"
    }
  }, [_c('div', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.showYundongyuanPicker = true
      }
    }
  }, [_vm._v("请选择人员 "), _c('i', {
    staticClass: "el-icon-arrow-right"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formData.yundongyuan.length > 0),
      expression: "formData.yundongyuan.length>0"
    }]
  }, _vm._l((_vm.formData.yundongyuan), function(yundongyuan, index) {
    return _c('div', {
      key: index,
      staticClass: "memberLi"
    }, [_c('el-tag', {
      key: index,
      attrs: {
        "round": "",
        "closable": "",
        "type": "primary"
      },
      on: {
        "close": function($event) {
          return _vm.formData.yundongyuan.splice(index, 1)
        }
      }
    }, [_vm._v(" " + _vm._s(yundongyuan.name) + "(" + _vm._s(yundongyuan.num) + ") " + _vm._s(yundongyuan.project) + "-" + _vm._s(yundongyuan.grade) + "\n                ")])], 1)
  }), 0)])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "footer-button"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveLoading
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("保存\n          ")])], 1)], 1)], 1), _vm._v(" "), _c('YundongyuanPicker', {
    attrs: {
      "show": _vm.showYundongyuanPicker,
      "limit": 30,
      "defaultValue": _vm.formData.yundongyuan
    },
    on: {
      "onChange": _vm.onYundongyuanChange,
      "onClose": function($event) {
        _vm.showYundongyuanPicker = false
      },
      "onConfirm": _vm.onYundongyuanConfirm
    }
  }), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3962f489","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/user/skill/LevelApply.vue
// module id = 1454
// module chunks = 0